const common = {
    authNavBarRegister: String("Registrarse"),
    authNavBarLogin: String("Iniciar sesión")
    
};

export default common;